import { cx } from '@emotion/css';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

const leftArrowIcon = getDesignSystemIcon('icon-arrow-left-16.svg');
const rightArrowIcon = getDesignSystemIcon('icon-arrow-right-16.svg');

export const ImageViewerNavigation = ({ currentImageIndex, setCurrentImageIndex, imagesCount }) => {
  return (
    <div className="flex items-center gap-4">
      <span className="text-nowrap stihl-text-body-sm-reg" data-testid={`sliderPosition${currentImageIndex + 1}_${imagesCount}`}>
        {currentImageIndex + 1} | {imagesCount}
      </span>
      <div className="flex gap-x-2 text-primary-white">
        <button
          className={cx(
            'flex h-8 w-8 items-center justify-center focus-outline',
            currentImageIndex === 0 ? 'bg-secondary' : 'bg-primary-black'
          )}
          disabled={currentImageIndex === 0}
          onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
          data-testid="prevPicture"
        >
          <PhoenixIcon icon={leftArrowIcon} />
        </button>
        <button
          className={cx(
            'flex h-8 w-8 items-center justify-center focus-outline',
            currentImageIndex === imagesCount - 1 ? 'bg-secondary' : 'bg-primary-black'
          )}
          disabled={currentImageIndex === imagesCount - 1}
          onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
          data-testid="nextPicture"
        >
          <PhoenixIcon icon={rightArrowIcon} />
        </button>
      </div>
    </div>
  );
};
